import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const ESTADOS = {
  activo: { label: 'Activo', bg: '#EAF3DE', color: '#3B6D11' },
  pausado: { label: 'Pausado', bg: '#F5EFD6', color: '#8B6914' },
  cerrado: { label: 'Cerrado', bg: '#f0f0ed', color: '#888' },
};

export default function Proyectos() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [proyectos, setProyectos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState(false);
  const [filtroEstado, setFiltroEstado] = useState('');
  const [vista, setVista] = useState(() => localStorage.getItem('proyectos_vista') || 'tarjetas');
  const [busqueda, setBusqueda] = useState('');
  const [sortCol, setSortCol] = useState('nombre');
  const [sortDir, setSortDir] = useState('asc');

  const toggleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const SortTh = ({col, label}) => (
    <th style={{padding:'10px 16px',fontSize:11,fontWeight:500,color:'#aaa',textAlign:'left',borderBottom:'0.5px solid #f0f0ed',textTransform:'uppercase',letterSpacing:'0.05em',cursor:'pointer',userSelect:'none',whiteSpace:'nowrap'}} onClick={() => toggleSort(col)}>
      {label} {sortCol === col ? (sortDir === 'asc' ? '↑' : '↓') : <span style={{color:'#ddd'}}>↕</span>}
    </th>
  );
  const [filtroCliente, setFiltroCliente] = useState('');
  const [form, setForm] = useState({ nombre: '', cliente: '', descripcion: '', estado: 'activo', fecha_inicio: '', fecha_fin: '', presupuesto: '', precio_hora_venta: '' });
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/proyectos').then(res => {
      setProyectos(res.data);
      setCargando(false);
    }).catch(() => setCargando(false));
  };

  const guardar = async () => {
    setError('');
    if (!form.nombre.trim()) { setError('El nombre es obligatorio'); return; }
    try {
      await API.post('/proyectos', {
        nombre: form.nombre,
        cliente: form.cliente || null,
        descripcion: form.descripcion || null,
        estado: form.estado,
        fecha_inicio: form.fecha_inicio || null,
        fecha_fin: form.fecha_fin || null,
        presupuesto: form.presupuesto ? parseFloat(form.presupuesto) : null,
        precio_hora_venta: form.precio_hora_venta ? parseFloat(form.precio_hora_venta) : null,
      });
      setModal(false);
      cargar();
    } catch(e) { setError(e.response?.data?.detail || 'Error al guardar'); }
  };

  const clientes = [...new Set(proyectos.map(p => p.cliente).filter(Boolean))];
  const proyectosFiltrados = [...proyectos].filter(p => {
    if (filtroEstado && p.estado !== filtroEstado) return false;
    if (filtroCliente && p.cliente !== filtroCliente) return false;
    if (busqueda && !p.nombre.toLowerCase().includes(busqueda.toLowerCase()) && !p.cliente?.toLowerCase().includes(busqueda.toLowerCase())) return false;
    return true;
  });

  const proyectosOrdenados = [...proyectosFiltrados].sort((a, b) => {
    let va = a[sortCol] ?? '';
    let vb = b[sortCol] ?? '';
    if (typeof va === 'string') va = va.toLowerCase();
    if (typeof vb === 'string') vb = vb.toLowerCase();
    if (va < vb) return sortDir === 'asc' ? -1 : 1;
    if (va > vb) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });

  const fmtFecha = (iso) => iso ? new Date(iso).toLocaleDateString('es-ES', {day:'2-digit', month:'2-digit', year:'numeric'}) : '—';

  if (cargando) return <div style={s.loading}>Cargando...</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div style={s.topbarTitle}>Proyectos</div>
        <div style={s.topbarActions}>
          <select style={s.select} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
            <option value="">Todos los estados</option>
            <option value="activo">Activos</option>
            <option value="pausado">Pausados</option>
            <option value="cerrado">Cerrados</option>
          </select>
          <input style={{padding:'7px 12px',borderRadius:8,border:'0.5px solid #d0d0c8',fontSize:13,outline:'none',width:180}} placeholder="Buscar proyecto..." value={busqueda} onChange={e => setBusqueda(e.target.value)} />
          <select style={s.select} value={filtroCliente} onChange={e => setFiltroCliente(e.target.value)}>
            <option value="">Todos los clientes</option>
            {clientes.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <div style={{display:'flex',background:'#f0f0ed',borderRadius:8,padding:2,gap:2}}>
            <button style={{background: vista==='tarjetas' ? 'white' : 'none', border:'none', borderRadius:6, padding:'5px 10px', cursor:'pointer', fontSize:13, color: vista==='tarjetas' ? '#1a1a1a' : '#888', boxShadow: vista==='tarjetas' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'}} onClick={() => { setVista('tarjetas'); localStorage.setItem('proyectos_vista','tarjetas'); }}>⊞</button>
            <button style={{background: vista==='lista' ? 'white' : 'none', border:'none', borderRadius:6, padding:'5px 10px', cursor:'pointer', fontSize:13, color: vista==='lista' ? '#1a1a1a' : '#888', boxShadow: vista==='lista' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'}} onClick={() => { setVista('lista'); localStorage.setItem('proyectos_vista','lista'); }}>≡</button>
          </div>
          {usuario?.rol === 'admin' && (
            <button style={s.btn} onClick={() => { navigate('/proyectos/nuevo'); }}>
              + Nuevo proyecto
            </button>
          )}
        </div>
      </div>

      <div style={s.content}>
        <div style={s.resumen}>
          <div style={s.resumenItem}><span style={s.resumenNum}>{proyectos.filter(p=>p.estado==='activo').length}</span><span style={s.resumenLabel}>Activos</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{proyectos.filter(p=>p.estado==='pausado').length}</span><span style={s.resumenLabel}>Pausados</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{proyectos.filter(p=>p.estado==='cerrado').length}</span><span style={s.resumenLabel}>Cerrados</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{proyectos.length}</span><span style={s.resumenLabel}>Total</span></div>
        </div>

        {proyectosFiltrados.length === 0 ? (
          <div style={s.empty}>
            <div style={s.emptyText}>No hay proyectos{filtroEstado ? ' en este estado' : ' aún'}</div>
            {!filtroEstado && usuario?.rol === 'admin' && <button style={s.btn} onClick={() => navigate('/proyectos/nuevo')}>Crear primer proyecto</button>}
          </div>
        ) : (
          <>{vista === 'tarjetas' ? (
            <div style={s.grid}>
              {proyectosFiltrados.map(p => (
                <div key={p.id} style={s.card} onClick={() => navigate(`/proyectos/${p.id}`)}
                  onMouseEnter={e => e.currentTarget.style.boxShadow='0 4px 12px rgba(0,0,0,0.08)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow='none'}>
                  <div style={s.cardTop}>
                    <span style={{...s.pill, background: ESTADOS[p.estado]?.bg, color: ESTADOS[p.estado]?.color}}>
                      {ESTADOS[p.estado]?.label}
                    </span>
                  </div>
                  <div style={s.cardNombre}>{p.nombre}</div>
                  {p.cliente && <div style={s.cardCliente}>{p.cliente}</div>}
                  <div style={s.cardMeta}>
                    <span>{p.fecha_inicio ? fmtFecha(p.fecha_inicio) : 'Sin fecha inicio'}</span>
                    {p.fecha_fin && <span> → {fmtFecha(p.fecha_fin)}</span>}
                  </div>
                  {p.presupuesto && <div style={s.cardPresupuesto}>{parseFloat(p.presupuesto).toLocaleString('es-ES')}€</div>}
                </div>
              ))}
            </div>
          ) : (
            <div style={{background:'white',border:'0.5px solid #e0e0d8',borderRadius:12,overflow:'hidden'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead>
                  <tr>
                    <SortTh col="nombre" label="Proyecto" />
                    <SortTh col="cliente" label="Cliente" />
                    <SortTh col="fecha_inicio" label="Fecha inicio" />
                    <SortTh col="fecha_fin" label="Fecha fin" />
                    <SortTh col="presupuesto" label="Presupuesto" />
                    <SortTh col="estado" label="Estado" />
                  </tr>
                </thead>
                <tbody>
                  {proyectosOrdenados.map(p => (
                    <tr key={p.id} style={{borderBottom:'0.5px solid #f0f0ed',cursor:'pointer'}}
                      onClick={() => navigate(`/proyectos/${p.id}`)}
                      onMouseEnter={e => e.currentTarget.style.background='#fafaf8'}
                      onMouseLeave={e => e.currentTarget.style.background='white'}>
                      <td style={{padding:'12px 16px',fontSize:13,fontWeight:500,color:'#1a1a1a'}}>{p.nombre}</td>
                      <td style={{padding:'12px 16px',fontSize:13,color:'#888'}}>{p.cliente || '—'}</td>
                      <td style={{padding:'12px 16px',fontSize:13,color:'#888'}}>{p.fecha_inicio ? fmtFecha(p.fecha_inicio) : '—'}</td>
                      <td style={{padding:'12px 16px',fontSize:13,color:'#888'}}>{p.fecha_fin ? fmtFecha(p.fecha_fin) : '—'}</td>
                      <td style={{padding:'12px 16px',fontSize:13,color:'#378ADD',fontWeight:600}}>{p.presupuesto ? `${parseFloat(p.presupuesto).toLocaleString('es-ES')}€` : '—'}</td>
                      <td style={{padding:'12px 16px'}}>
                        <span style={{...s.pill, background: ESTADOS[p.estado]?.bg, color: ESTADOS[p.estado]?.color}}>{ESTADOS[p.estado]?.label}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          </>
        )}
      </div>

      {modal && (
        <div style={s.overlay} onClick={() => setModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div style={s.modalTitle}>Nuevo proyecto</div>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Nombre del proyecto" /></div>
            <div style={s.field}><label style={s.label}>Cliente</label><input style={s.input} value={form.cliente} onChange={e => setForm({...form, cliente: e.target.value})} placeholder="Nombre del cliente" /></div>
            <div style={s.field}><label style={s.label}>Descripción</label><textarea style={{...s.input, height:72, resize:'vertical'}} value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})} placeholder="Descripción opcional" /></div>
            <div style={s.field}>
              <label style={s.label}>Estado</label>
              <select style={s.input} value={form.estado} onChange={e => setForm({...form, estado: e.target.value})}>
                <option value="activo">Activo</option>
                <option value="pausado">Pausado</option>
                <option value="cerrado">Cerrado</option>
              </select>
            </div>
            <div style={s.fieldRow}>
              <div style={{...s.field, flex:1}}><label style={s.label}>Fecha inicio</label><input style={s.input} type="date" value={form.fecha_inicio} onChange={e => setForm({...form, fecha_inicio: e.target.value})} /></div>
              <div style={{...s.field, flex:1}}><label style={s.label}>Fecha fin</label><input style={s.input} type="date" value={form.fecha_fin} onChange={e => setForm({...form, fecha_fin: e.target.value})} /></div>
            </div>
            <div style={s.fieldRow}>
              <div style={{...s.field, flex:1}}><label style={s.label}>Presupuesto (€)</label><input style={s.input} type="number" value={form.presupuesto} onChange={e => setForm({...form, presupuesto: e.target.value})} placeholder="0" /></div>
              <div style={{...s.field, flex:1}}><label style={s.label}>Precio hora venta (€)</label><input style={s.input} type="number" value={form.precio_hora_venta} onChange={e => setForm({...form, precio_hora_venta: e.target.value})} placeholder="0" /></div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardar}>Crear proyecto</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center', justifyContent:'space-between' },
  topbarTitle: { fontSize:14, fontWeight:500, color:'#1a1a1a' },
  topbarActions: { display:'flex', gap:10, alignItems:'center' },
  content: { padding:24, display:'flex', flexDirection:'column', gap:16 },
  resumen: { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12 },
  resumenItem: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:10, padding:'12px 16px', display:'flex', flexDirection:'column', gap:2 },
  resumenNum: { fontSize:22, fontWeight:600, color:'#1a1a1a' },
  resumenLabel: { fontSize:11, color:'#aaa', textTransform:'uppercase', letterSpacing:'0.05em' },
  grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:16 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:20, cursor:'pointer', transition:'box-shadow 0.15s' },
  cardTop: { marginBottom:12 },
  cardNombre: { fontSize:15, fontWeight:600, color:'#1a1a1a', marginBottom:4 },
  cardCliente: { fontSize:13, color:'#888', marginBottom:8 },
  cardMeta: { fontSize:12, color:'#aaa', marginBottom:8 },
  cardPresupuesto: { fontSize:13, fontWeight:600, color:'#378ADD' },
  pill: { fontSize:11, padding:'2px 8px', borderRadius:10, fontWeight:500 },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  select: { padding:'7px 10px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:13, background:'white', outline:'none' },
  empty: { textAlign:'center', padding:'64px 0', display:'flex', flexDirection:'column', alignItems:'center', gap:16 },
  emptyText: { fontSize:14, color:'#aaa' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal: { background:'white', borderRadius:12, border:'0.5px solid #e0e0d8', padding:24, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto' },
  modalHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 },
  modalTitle: { fontSize:15, fontWeight:500, color:'#1a1a1a' },
  closeBtn: { background:'none', border:'none', fontSize:16, cursor:'pointer', color:'#aaa' },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 },
};
